<template>
  <div class="delete-request">
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="sendOk">
        <p>
          Uw verzoek is verzonden.
        </p>
      </div>
    </transition>
    <div class="dialog-header">
      <h1>Verzoek tot beëindigen account</h1>
    </div>
    <div class="dialog-content">
      <p>
        Door op "bevestigen" te klikken dient u een verzoek in tot het
        beëindigen van uw Rijnja.nl account en het wissen van uw gegevens binnen
        onze systemen.<br />U ontvangt van ons een bevestiging van dit verzoek.
      </p>
      <div class="button-holder">
        <button class="pill-button secondary" @click="$emit('close')">
          Annuleren
        </button>
        <button class="pill-button" @click="sendRequest">
          bevestigen
        </button>
      </div>
      <p class="error-text" v-if="sendError">
        Er is een probleem opgetreden bij het verzenden van uw verzoek. Probeer
        het later nogmaals of neem contact op met de helpdesk: Tel. 030 28 49
        305.
      </p>
    </div>
  </div>
</template>
<script>
import { sendMail } from '@/api/api'
import { useRootStore } from '@/stores/store'

export default {
  data() {
    const rootStore = useRootStore()

    return {
      sendError: false,
      sendOk: false,
      contact: {
        subject: 'Verzoek tot stoppen account',
        title: 'Verzoek tot beëindigen account',
        userInfo: {
          name: rootStore.user.name,
          email: rootStore.user.username
        },
        message: 'Verzoek tot beëindigen account',
        to: 'helpdesk@rijnja.nl'
      }
    }
  },
  methods: {
    sendRequest() {
      sendMail(this.contact).then((val) => {
        if (val === true) {
          this.sendOk = true

          setTimeout(() => {
            this.$emit('close')
          }, 1500)
        } else {
          this.sendError = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.secondary {
  margin-right: 5px;
}

.error-text {
  padding-top: 20px;
}
</style>
